export function alterarToken(token: any) {
  return {
    type: "ALTERA_TOKEN",
    payload: token,
  };
}

export const alterarWhiteLabel = (whitelabel: any) => {
  return {
    type: "CHANGE_WHITELABEL",
    payload: whitelabel,
  };
};

export const alterarLayout = (layout: any) => {
  return {
    type: "CHANGE_LAYOUT",
    payload: layout,
  };
};


